var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3525 16.9668L19 19.0156L26.6475 21.0644L34.2942 23.1133C36.1451 16.206 33.1289 9.14033 27.3489 5.55725C26.0295 4.74025 24.5971 4.12168 23.0977 3.72138C21.3767 3.25842 19.5897 3.08979 17.8125 3.22262C11.2915 3.71346 5.49417 8.24258 3.70659 14.9179L11.3533 16.9668H11.3525Z",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0977 3.72137C23.0977 3.72137 18.6327 6.62283 16.0788 10.0365C13.5248 13.4502 12.8828 17.376 12.8828 17.376",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0977 3.72137C23.0977 3.72137 25.5146 8.46742 26.0189 12.7005C26.5248 16.9335 25.1172 20.6543 25.1172 20.6543",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70659 14.9179L11.3533 16.9667L19 19.0156L26.6475 21.0644L34.2942 23.1132",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16667 34.8489H34.8333",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.0156L14.6458 34.8489",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 3.22184C19.5898 3.08927 21.3767 3.25816 23.0977 3.72138C24.5971 4.12169 26.0295 4.74026 27.3489 5.55726",
    stroke: "white",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUmbrella);
export default __webpack_public_path__ + "static/media/icon_umbrella.05ee19476ab4b4f854e5921fdea37a7c.svg";
export { ForwardRef as ReactComponent };